(function (angular) {
  'use strict';

  angular
    .module('bossApp.login', [])
    .component('login', {
      templateUrl: 'src/app/components/login/marketing-template.html',
      controller: LoginCtrl,
      controllerAs: 'loginCtrl',
      bindings: {}
    });

  LoginCtrl.$inject = ['$state', 'loginService', '$window', '$log', 'URLS', 'user', '$element', '$timeout', 'openwebPath', 'originPath', '$sce', 'adobeAnalyticsService'];

  function LoginCtrl ($state, loginService, $window, $log, URLS, user, $element, $timeout, openwebPath, originPath, $sce, adobeAnalyticsService) {
    var vm = this;
    var script = document.createElement('script');
    // si la ruta es absoluta no concatenes
    script.src = openwebPath + '/' + 'third-party/script.min.js';
    script.type = 'text/javascript';
    script.async = false;
    
    function getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      // iOS detection from:
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    }

    var fallbackToStore = function() {
      if (getMobileOperatingSystem() == "iOS") {
        window.location.replace('https://itunes.apple.com/es/app/bbva-net-cash-es-pt/id698168058?mt=8');
      } else {
        window.location.replace('market://details?id=com.bbva.netcash');
      }
    };
    
    var isSafariBrowser = function() {
      return Boolean(navigator.userAgent.match(/^.*(iPhone|iPad).*(Version).*(safari).*$/i));
    }

    var openApp = function() {
      window.location.replace('bbvanetcash://app');
    };

    var openAppTry = function () {
      var returnedValue;
      returnedValue = window.open('bbvanetcash://app');
      if (!returnedValue) throw 'openAppError';
    };
    
    vm.triggerAppOpen = function() {
      if(isSafariBrowser()) {
        try {
            openAppTry();

        } catch (error) {
            fallbackToStore();
        }
      } else {
        openApp();
        setTimeout(fallbackToStore, 500);
      }
    };


    function getInternetExplorerVersion () {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      var rv = -1;
      var version = undefined;

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {

        if (isNaN(parseInt(ua.substring(msie + 5, ua.indexOf('.', msie))))) {
          //For IE 11 >
          if (navigator.appName === 'Netscape') {
            var ua = navigator.userAgent;
            var re = new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
              version = rv;
            }
          } else {
            version = undefined;
          }
        } else {
          version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)));
        }
      }
      return version;
    }

    document.head.appendChild(script);
    vm.$onInit = function () {
      $window.addEventListener('message', messageHandler, false);

      vm.openwebPath = openwebPath;
      vm.user = user;
      vm.loader = false;
      vm.errorCode = '';
      vm.user.remember_me = true;
      vm.hasViewedCookiesDisclaimer = localStorage.getItem('hasViewedCookiesDisclaimer');
      vm.openLogin = $element.find('.open-login');
      vm.openLogin.on('click', vm.onOpenLogin);
      vm.IEBrowserVersion = getInternetExplorerVersion();
      vm.showErrorAlert = false;
      vm.showInfoAlert = false;
      vm.expired = false;
      vm.inactivity = false;

      $timeout(function() {
        checkStatus();
      }, 0)
      
      var favicon = document.querySelector("link[rel*='icon']")
      favicon.href = 'https:' +  vm.openwebPath + '/' + 'images/icons/favicon.ico';

      var origen = location.origin.split('.').slice(1).join('.');
      vm.dcaUrl = (origen === 'bbvaoneview.com') ? "https://empresas.bbva.es/haztecliente/#!/oneview" : "https://bbva-files.s3.amazonaws.com/cells/apps/pgibc/pgibc_deploy/1310-oneview/cellsapp/dev/vulcanize/index.html#!/oneview";
      
      var _json = null;
      try {
        _json = angular.fromJson($window.atob(localStorage.getItem('BBVAbossRememberMe')));
      } catch (error) {
        // nothing
      }
      if (_json !== null) {
        vm.user.cod_emp = _json.cod_emp;
        vm.user.cod_usu = _json.cod_usu;
        vm.user.remember_me = true;
      }
      $window.$('.open-login').click(function () {
        $window.$('.login-container').addClass('show');
        $window.$('.btn-Login').addClass('login-in');

      });

      $window.$('.close-login').click(function () {
        $window.$('.login-container').removeClass('show');
        $window.$('.btn-Login').removeClass('login-in');
      });

      $window.$('.app-checkbox').click(function () {
        $window.$(this).toggleClass('md-checked');
      });

      $window.$('.launch-dataform').click(function () {
        $window.$('.form-data').hide();
        $window.$('.form-success').show();
      });
    };

    vm.setDisclaimerView = setDisclaimerView;

    function setDisclaimerView (e) {
      localStorage.setItem('hasViewedCookiesDisclaimer', 'true');
      vm.hasViewedCookiesDisclaimer = 'true';
    }

    vm.onCloseAlert = function () {
      $element.find('#alertBlock').slideUp();
    };

    vm.onOpenLogin = function onOpenLogin () {
      $timeout(function () {

        $element.find('form input.ng-invalid').first().focus();
      }, 10);

    };

    function checkStatus () {
      var status = localStorage.getItem('ngStorage-status');

      if(status) {
        status = JSON.parse(status);
        vm.expired = status === 'expired';
        vm.inactivity = status === 'inactivity';
        localStorage.removeItem('ngStorage-status');
      } else {
        vm.expired = false;
        vm.inactivity = false;
      }
      vm.showInfoAlert = (vm.expired || vm.inactivity);
      if(vm.showInfoAlert) {
        $element.find('#alertBlock').slideDown();
      }
    }

    vm.onSubmit = function (form) {
      vm.onCloseAlert();
      if (vm.user.remember_me) {
        var _json = {};
        _json.cod_emp = vm.user.cod_emp;
        _json.cod_usu = vm.user.cod_usu;
        if (_json.cod_emp && _json.cod_usu) {
          localStorage.setItem('BBVAbossRememberMe', $window.btoa(angular.toJson(_json)));
        }
      } else {
        localStorage.removeItem('BBVAbossRememberMe');
      }

      if (form.$invalid) {
        $element.find('form .ng-invalid').focus();
        return;
      }

      vm.authenticating = true;

      loginService.loginRequest(vm.user)
        .then(function (responseObj) {
          $log.info('redireccionando: ', location.origin + URLS.urlBoss.url);
          $window.location.href = location.origin + URLS.urlBoss.url;
        })
        // En caso de login incorrecto mostarmos el mensaje de error
        .catch(function (errorInfo) {
          vm.errorMessage = errorInfo.errorRTS ? errorInfo.errorMsg : 'No es posible acceder al servicio. ' + errorInfo.errorMsg;
          vm.errorMessageTrusted = $sce.trustAsHtml(vm.errorMessage);
          vm.authenticating = false;
          vm.showErrorAlert = true;
          vm.showInfoAlert = false;

          if(URLS.setError) {
            vm.isWarning = true;
          } else {
            vm.isWarning = false;
          }
          
          $element.find('#alertBlock').slideDown();
        });
    };

    vm.logout = function () {
      loginService.logoutRequest().then(
        function (responseObj) {
          $log.log('LoginCtrl - logout - then - ' + responseObj);
//            $log.log(responseObj);
        }
      ).catch(
        function (response) {
          $log.error('LoginCtrl - logout - catch - ' + response);
          $log.error(response);
        }
      );
    };

    function messageHandler (event) {
      if (event && event.data && event.data.msg) {
        switch (event.data.msg) {
          case 'closed':
            $state.go('login');
            break;
          case 'formSent':
            $state.go('login.openWebForm.success');
            break;
          default:

        }
      }
    }

    vm.sendAnalytics = function (type, label, extraInfo) {
      var trackingObject = {
        interactionType: type,
        interactionLabel: label,
        interactionLocation: 'marketing-template',
        extraInfo: extraInfo
      };

      adobeAnalyticsService.viewTracking(trackingObject);
    }
  }

})(angular);
